<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-ad_units-F"></i><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.TitleHeader" | translate }} </span>
  </div>

  <ng-container *ngIf="order.invoice?.PhoneNumber?.startsWith('09'); else elseTemplate">
    <div
      class="content"
      *ngIf="order.currentSaleMethodNature !== order.SaleMethodNature.Restaurant || order.invoice.StatusCode !== order.InvoiceStatus.New">
      <ssg-checkbox
        *ngIf="order.saleMethodBranch?.HasFactorLink"
        id="HasFactorLink"
        [group]="formGroup"
        name="HasFactorLink"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.FactorLink' | translate"
        (valueChange)="onFactorLinkChanges($event)">
      </ssg-checkbox>
      <ssg-checkbox
        *ngIf="
          order.currentInformation.PaymentPanelAVA &&
          order.saleMethodBranch?.HasPaymentLink &&
          order.currentSaleMethodNature !== order.SaleMethodNature.FastFood
        "
        id="HasPaymentLink"
        [group]="formGroup"
        name="HasPaymentLink"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.PaymentLink' | translate"
        (valueChange)="onPaymentLinkChanges($event)">
      </ssg-checkbox>
    </div>
    <p *ngIf="order.invoice?.Customer?.AutomaticDebtor" class="payment-link-fast-access-message">
      {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.SendLinkCustomerAutomaticallyDebt" | translate }}
    </p>
  </ng-container>

  <ng-template #elseTemplate>
    <p *ngIf="!order.invoice?.PhoneNumber?.startsWith('09')" class="payment-link-fast-access-message">
      {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.InvoiceMobileNumber" | translate }}
    </p>
  </ng-template>
</div>
